/**
 * Reusable Checkbox (Toggle Style) Component
 */

import { Fragment, h } from "preact";
import { forwardRef } from "preact/compat";
import { Icon } from ".";

type ToggleProps = {
  id: string;
  toggled: boolean;
  // eslint-disable-next-line no-unused-vars
  onToggle: (val: boolean) => void;
  label?: string;
  iconType?: string; // optional icon to left of label
  ref: HTMLInputElement;
  srLabel?: string;
};

const Toggle = forwardRef<HTMLInputElement, ToggleProps>(
  ({ id, toggled, onToggle, label, iconType, srLabel }, ref) => (
    <Fragment>
      <input
        class="srOnly Toggle-checkbox"
        id={id}
        data-testid={id}
        ref={ref}
        type="checkbox"
        onClick={() => onToggle(!toggled)}
        checked={toggled}
      />
      <label for={id} class="Toggle-toggle">
        {iconType && <Icon type={iconType} style="Toggle-icon" />}
        {srLabel && <span class="srOnly">{srLabel}</span>}
        {label}
      </label>
    </Fragment>
  )
);
export default Toggle;
